
import dateFormatMixin from '@/mixins/dateFormat'

import VanIcon from '@/static/svg/prescription/van-icon.svg'
import ProgressBar from '@/components/ProgressBar'
import InfoTooltip from '@/components/InfoTooltip'

export default {
  components: {
    VanIcon,
    ProgressBar,
    InfoTooltip,
  },
  mixins: [dateFormatMixin],
  props: {
    shippingSelectorMode: {
      type: Boolean,
      default: false,
    },
    tooltipText: {
      type: String,
      default: '',
    },
    isLoading: {
      type: Boolean,
      default: false,
    },
    hasError: {
      type: Boolean,
      default: false,
    },
    deliveryDateFrom: {
      type: String,
      default: '',
    },
    deliveryDateTo: {
      type: String,
      default: '',
    },
    deliveryDateCutoff: {
      type: String,
      default: '',
    },
    withCutoff: {
      type: Boolean,
      default: true,
    },
    trackDeliveryEstimateChanged: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    combinedDeliveryFromAndTo() {
      return `${this.deliveryDateFrom} ${this.deliveryDateTo}`
    },
  },
  watch: {
    combinedDeliveryFromAndTo() {
      this.deliveryEstimateChanged()
    },
  },
  methods: {
    deliveryEstimateChanged() {
      if (this.trackDeliveryEstimateChanged) {
        this.$gtm.push({ event: 'deliveryEstimateUpdated' })
      }
    },
  },
}
